import { withConfigServiceTNT } from './withConfigServiceTNT';
/**
 * @deprecated Use withConfigServiceTNT instead.
 */

export function withMagicApronTNT(BaseComponent) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const Deprecated = withConfigServiceTNT(BaseComponent, opts);
  Deprecated.displayName = 'withMagicApronTNT';
  return Deprecated;
}
//# sourceMappingURL=withMagicApronTNT.js.map